
export default function Hero() {
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToAbout = () => {
    const aboutSection = document.getElementById('about');
    if (aboutSection) {
      aboutSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleBookAppointment = () => {
    window.open('https://cal.com/cita-doctor-nntskz/ginecologo-german', '_blank');
  };

  return (
    <section 
      className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20"
      style={{
        backgroundImage: `linear-gradient(135deg, rgba(255, 182, 193, 0.15) 0%, rgba(173, 216, 230, 0.15) 100%), url(https://readdy.ai/api/search-image?query=Professional%20modern%20medical%20consultation%20room%20with%20soft%20natural%20lighting%20featuring%20comfortable%20seating%20area%20and%20calming%20pastel%20pink%20and%20blue%20accents%20creating%20a%20welcoming%20atmosphere%20for%20women%20healthcare%20with%20clean%20minimalist%20design%20and%20gentle%20aesthetic%20perfect%20for%20gynecology%20practice&width=1920&height=1080&seq=hero001&orientation=landscape)`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-white/95 via-white/85 to-transparent"></div>
      
      <div className="container mx-auto px-6 py-20 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div className="space-y-4">
              <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
                Dr. Germán Delgadillo, Ginecólogo con{' '}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-400 to-blue-400">
                  empatía y experiencia
                </span>
              </h1>
              <p className="text-xl text-gray-600 leading-relaxed">
                Atención ginecológica integral en un entorno cálido y profesional
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <button 
                onClick={handleBookAppointment}
                className="px-8 py-4 bg-gradient-to-r from-pink-400 to-pink-500 text-white rounded-full font-semibold hover:from-pink-500 hover:to-pink-600 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                Agendar cita
              </button>
              <button 
                onClick={scrollToAbout}
                className="px-8 py-4 bg-white text-gray-700 rounded-full font-semibold hover:bg-gray-50 transition-all duration-300 border-2 border-gray-200 whitespace-nowrap cursor-pointer"
              >
                Conoce más sobre mí
              </button>
            </div>

            <div className="grid grid-cols-3 gap-6 pt-8">
              <div className="text-center">
                <div className="text-3xl font-bold text-pink-5.00">15+</div>
                <div className="text-sm text-gray-600 mt-1">Años de experiencia</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-blue-400">5000+</div>
                <div className="text-sm text-gray-600 mt-1">Pacientes atendidas</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-pink-500">99%</div>
                <div className="text-sm text-gray-600 mt-1">Satisfacción</div>
              </div>
            </div>
          </div>

          <div className="hidden lg:flex justify-center items-center">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-br from-pink-300/30 to-blue-300/30 rounded-3xl blur-3xl"></div>
              <img
                src="https://static.readdy.ai/image/f15b91f1c882dc85fb9b8fcd7db718c1/ffc2dc459b255a39a8efbee2afacb760.png"
                alt="Dr. Germán Delgadillo Espejo"
                className="relative rounded-3xl shadow-2xl w-full max-w-md object-cover"
              />
              {/* Sello de certificación CONACEM */}
              <div className="absolute -top-3 -right-3 w-24 h-24 bg-white rounded-full shadow-2xl p-2 border-4 border-yellow-400 ring-4 ring-yellow-300/50 ring-offset-2 ring-offset-white">
                <div className="w-full h-full bg-gradient-to-br from-yellow-50 to-yellow-100 rounded-full p-1 shadow-inner">
                  <img
                    src="https://static.readdy.ai/image/f15b91f1c882dc85fb9b8fcd7db718c1/c612b21bac0d992f053b10d9a2aa11bf.png"
                    alt="Certificación CONACEM"
                    className="w-full h-full object-contain filter drop-shadow-sm"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
